import React from "react" // 👈️ React Imports
import ContentLoader from "react-content-loader" // 👈️ Third Party Components

export const Loading = (props) => ( // 👈️ Loading Contents
  <ContentLoader 
    speed={1}
    width={100}
    height={25}
    viewBox="50 0 100 50"
    {...props}
  >
    <circle cx="10" cy="20" r="8" /> 
    <rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
)

export const LineLoader = (props) => ( // 👈️ Loading Contents
  <ContentLoader 
    speed={1}
    width={100}
    height={25}
    viewBox="50 0 100 50"
    {...props}
  >
    <rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
)

export const TableLoader = props => ( // 👈️ Loading Contents for Table
  <ContentLoader {...props}>
  <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />{/*  👈️ Left Vertical Line */}
    <rect x="51" y="45" rx="3" ry="3" width="93.2%" height="17"/>
      <rect x="53" y="57" rx="3" ry="3" width="3%" height="33"/>
      <rect x="280" y="57" rx="3" ry="3" width="1.5%" height="33"/>
      <rect x="655" y="57" rx="3" ry="3" width=".5%" height="33"/>
      <rect x="840" y="57" rx="3" ry="3" width="1.2%" height="33"/>
      <rect x="1210" y="57" rx="3" ry="3" width=".5%" height="33"/>
    <rect x="52" y="80" rx="3" ry="3" width="93.2%" height="17"/>

    <rect x="83%" y="112" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="112" rx="3" ry="3" width="20" height="20"/>
    <circle cx="91%" cy="123" r="11" />
    <circle cx="94%" cy="123" r="11" />

    <rect x="104" y="115" rx="3" ry="3" width="10%" height="15" />
    <rect x="305" y="114" rx="3" ry="3" width="20%" height="15" />
    <rect x="661" y="114" rx="3" ry="3" width="10%" height="15" />
    <rect x="861" y="114" rx="3" ry="3" width="20%" height="15" />
    <rect x="1220" y="114" rx="3" ry="3" width="10%" height="15" />
    <rect x="55" y="155" rx="3" ry="3" width="93%" height="2" />

    <rect x="83%" y="173" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="173" rx="3" ry="3" width="20" height="20"/>
    <circle cx="91%" cy="184" r="11" />
    <circle cx="94%" cy="184" r="11" />

    <rect x="105" y="176" rx="3" ry="3" width="10%" height="15" />
    <rect x="306" y="175" rx="3" ry="3" width="20%" height="15" />
    <rect x="662" y="175" rx="3" ry="3" width="10%" height="15" />
    <rect x="861" y="175" rx="3" ry="3" width="20%" height="15" />
    <rect x="1220" y="175" rx="3" ry="3" width="10%" height="15" />
    <rect x="56" y="216" rx="3" ry="3" width="93%" height="2" />
    
    <rect x="83%" y="231" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="231" rx="3" ry="3" width="20" height="20"/>
    <circle cx="91%" cy="242" r="11" />
    <circle cx="94%" cy="242" r="11" />

    <rect x="106" y="234" rx="3" ry="3" width="10%" height="15" />
    <rect x="307" y="233" rx="3" ry="3" width="20%" height="15" />
    <rect x="663" y="233" rx="3" ry="3" width="10%" height="15" />
    <rect x="861" y="233" rx="3" ry="3" width="20%" height="15" />
    <rect x="1220" y="233" rx="3" ry="3" width="10%" height="15" />
    <rect x="57" y="274" rx="3" ry="3" width="93%" height="2" />

    <rect x="83%" y="292" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="292" rx="3" ry="3" width="20" height="20"/>
    <circle cx="91%" cy="303" r="11" />
    <circle cx="94%" cy="303" r="11" />

    <rect x="107" y="295" rx="3" ry="3" width="10%" height="15" />
    <rect x="308" y="294" rx="3" ry="3" width="20%" height="15" />
    <rect x="664" y="294" rx="3" ry="3" width="10%" height="15" />
    <rect x="861" y="294" rx="3" ry="3" width="20%" height="15" />
    <rect x="1220" y="294" rx="3" ry="3" width="10%" height="15" />
    <rect x="58" y="335" rx="3" ry="3" width="93%" height="2" />

    <rect x="83%" y="352" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="352" rx="3" ry="3" width="20" height="20"/>
    <circle cx="91%" cy="363" r="11" />
    <circle cx="94%" cy="363" r="11" />

    <rect x="106" y="355" rx="3" ry="3" width="10%" height="15" />
    <rect x="307" y="354" rx="3" ry="3" width="20%" height="15" />
    <rect x="663" y="354" rx="3" ry="3" width="10%" height="15" />
    <rect x="861" y="354" rx="3" ry="3" width="20%" height="15" />
    <rect x="1220" y="354" rx="3" ry="3" width="10%" height="15" />
    <rect x="57" y="395" rx="3" ry="3" width="93%" height="2" />

    <rect x="83%" y="413" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="413" rx="3" ry="3" width="20" height="20"/>
    <circle cx="91%" cy="424" r="11" />
    <circle cx="94%" cy="424" r="11" />

    <rect x="107" y="416" rx="3" ry="3" width="10%" height="15" />
    <rect x="308" y="415" rx="3" ry="3" width="20%" height="15" />
    <rect x="664" y="415" rx="3" ry="3" width="10%" height="15" />
    <rect x="861" y="415" rx="3" ry="3" width="20%" height="15" />
    <rect x="1220" y="415" rx="3" ry="3" width="10%" height="15" />
    <rect x="55" y="453" rx="3" ry="3" width="93%" height="2" />

    <rect x="83%" y="473" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="473" rx="3" ry="3" width="20" height="20"/>
    <circle cx="91%" cy="484" r="11" />
    <circle cx="94%" cy="484" r="11" />

    <rect x="83%" y="292" rx="3" ry="3" width="20" height="20"/>
    <rect x="87%" y="292" rx="3" ry="3" width="20" height="20"/>
    <rect x="107" y="476" rx="3" ry="3" width="10%" height="15" />
    <rect x="308" y="475" rx="3" ry="3" width="20%" height="15" />
    <rect x="664" y="475" rx="3" ry="3" width="10%" height="15" />
    <rect x="861" y="475" rx="3" ry="3" width="20%" height="15" />
    <rect x="1220" y="475" rx="3" ry="3" width="10%" height="15" />
    <rect x="55" y="513" rx="3" ry="3" width="93%" height="2" />

  <rect x="96%" y="49" rx="3" ry="3" width="2" height="465" /> {/* 👈️ Right Vertical Line */} 
    
  </ContentLoader>
)

export const ResponsiveViewPageLoader = props => ( // 👈️ Loading Contents for View Page
  <ContentLoader
    width={1280}
    height={900}
    viewBox="0 0 1280 900"
    {...props}
  >
    <rect x="753" y="419" rx="5" ry="5" width="510" height="2" />
    <rect x="147" y="24" rx="0" ry="0" width="540" height="540" />
    <rect x="12" y="25" rx="0" ry="0" width="104" height="109" />
    <rect x="11" y="165" rx="0" ry="0" width="104" height="109" />
    <rect x="11" y="305" rx="0" ry="0" width="105" height="109" />
    <rect x="753" y="27" rx="0" ry="0" width="160" height="18" />
    <rect x="753" y="63" rx="0" ry="0" width="496" height="32" />
    <rect x="753" y="189" rx="0" ry="0" width="45" height="16" />
    <rect x="753" y="224" rx="0" ry="0" width="80" height="80" />
    <rect x="11" y="451" rx="0" ry="0" width="105" height="109" />
    <rect x="73" y="479" rx="0" ry="0" width="2" height="14" />
    <rect x="753" y="127" rx="20" ry="20" width="101" height="32" />
    <rect x="872" y="128" rx="21" ry="21" width="85" height="32" />
    <rect x="972" y="125" rx="20" ry="20" width="146" height="32" />
    <rect x="1133" y="127" rx="20" ry="20" width="66" height="32" />
    <rect x="828" y="190" rx="0" ry="0" width="175" height="16" />
    <rect x="937" y="194" rx="0" ry="0" width="8" height="8" />
    <rect x="854" y="224" rx="0" ry="0" width="80" height="80" />
    <rect x="954" y="224" rx="0" ry="0" width="80" height="80" />
    <rect x="753" y="309" rx="0" ry="0" width="80" height="5" />
    <rect x="753" y="364" rx="0" ry="0" width="53" height="16" />
    <rect x="828" y="348" rx="25" ry="25" width="432" height="42" />
    <rect x="753" y="459" rx="0" ry="0" width="140" height="32" />
    <rect x="1150" y="521" rx="0" ry="0" width="6" height="4" />
    <rect x="1157" y="496" rx="0" ry="0" width="49" height="5" />
    <rect x="753" y="504" rx="0" ry="0" width="70" height="12" />
    <rect x="753" y="549" rx="25" ry="25" width="435" height="42" />
    <rect x="1101" y="459" rx="25" ry="25" width="48" height="48" />
    <rect x="1213" y="459" rx="25" ry="25" width="48" height="48" />
    <rect x="1172" y="461" rx="0" ry="0" width="16" height="30" />
    <rect x="1212" y="547" rx="25" ry="25" width="48" height="48" />
    <rect x="12" y="627" rx="0" ry="0" width="175" height="18" />
    <circle cx="20" cy="675" r="8" />
    <rect x="40" y="670" rx="0" ry="0" width="331" height="12" />
    <circle cx="20" cy="701" r="8" />
    <rect x="40" y="696" rx="0" ry="0" width="331" height="12" />
    <circle cx="20" cy="727" r="8" />
    <rect x="40" y="722" rx="0" ry="0" width="331" height="12" />
    <circle cx="20" cy="754" r="8" />
    <rect x="40" y="749" rx="0" ry="0" width="331" height="12" />
    <rect x="11" y="800" rx="0" ry="0" width="566" height="12" />
    <rect x="11" y="882" rx="0" ry="0" width="566" height="12" />
    <rect x="11" y="817" rx="0" ry="0" width="566" height="12" />
    <rect x="11" y="838" rx="0" ry="0" width="566" height="12" />
    <rect x="11" y="860" rx="0" ry="0" width="566" height="12" />
    <rect x="895" y="635" rx="0" ry="0" width="175" height="18" />
    <circle cx="903" cy="683" r="8" />
    <rect x="923" y="678" rx="0" ry="0" width="331" height="12" />
    <circle cx="903" cy="709" r="8" />
    <rect x="923" y="704" rx="0" ry="0" width="331" height="12" />
    <circle cx="903" cy="735" r="8" />
    <rect x="923" y="730" rx="0" ry="0" width="331" height="12" />
    <circle cx="903" cy="762" r="8" />
    <rect x="923" y="757" rx="0" ry="0" width="331" height="12" />
  </ContentLoader>
)

export const DataTableLoader = props => { // 👈️ Loading Contents - Datatable
  return (
    <ContentLoader
      width={1200}
      height={200}
      viewBox="0 0 1200 200"
      {...props}
    >
      <rect x="27" y="0" rx="4" ry="4" width="20" height="20" />
      <rect x="67" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="188" y="0" rx="10" ry="10" width="169" height="19" />
      <rect x="402" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="523" y="0" rx="10" ry="10" width="169" height="19" />
      <rect x="731" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="852" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="978" y="0" rx="10" ry="10" width="169" height="19" />

      <rect x="26" y="40" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="40" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="40" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="40" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="40" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="40" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="40" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="40" rx="10" ry="10" width="169" height="19" />

      <rect x="26" y="80" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="80" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="80" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="80" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="80" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="80" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="80" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="80" rx="10" ry="10" width="169" height="19" />

      <rect x="26" y="120" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="120" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="120" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="120" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="120" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="120" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="120" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="120" rx="10" ry="10" width="169" height="19" />

      <rect x="26" y="160" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="160" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="160" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="160" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="160" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="160" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="160" rx="10" ry="10" width="85" height="19" />
      <rect x="977" y="160" rx="10" ry="10" width="169" height="19" />
      
    </ContentLoader>
  )
}

export const DataTableOneRowLoader = props => { // 👈️ Loading Contents - One Row DataTable
  return (
    <ContentLoader
      width={1200}
      height={50}
      viewBox="0 0 1200 50"
      {...props}
    >
      <rect x="27" y="0" rx="4" ry="4" width="20" height="20" />
      <rect x="67" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="188" y="0" rx="10" ry="10" width="169" height="19" />
      <rect x="402" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="523" y="0" rx="10" ry="10" width="169" height="19" />
      <rect x="731" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="852" y="0" rx="10" ry="10" width="85" height="19" />
      
    </ContentLoader>
  )
}

export const DashboardLoader = props => { // 👈️ Loading Contents - One Row DataTable
  return (
    <ContentLoader
      width={'100%'}
      height={200}
      viewBox="0 0 1750 50"
      {...props}
    >
      <rect x="27" y="0" rx="4" ry="4" width="20" height="20" />
      <rect x="67" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="188" y="0" rx="10" ry="10" width="169" height="19" />
      <rect x="402" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="523" y="0" rx="10" ry="10" width="169" height="19" />
      <rect x="731" y="0" rx="10" ry="10" width="85" height="19" />
      <rect x="852" y="0" rx="10" ry="10" width="85" height="19" />
      
    </ContentLoader>
  )
}

export const ResponsiveReportLoader = props => { // 👈️ Loading Contents - Responsive Report
  return (
    <ContentLoader viewBox="0 0 750 650" height={650} width={'100%'} {...props}>
      <rect x="0" y="10" rx="5" ry="5" width="100%" height="200" />
      <rect x="0" y="265" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="285" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="305" rx="5" ry="5" width="100%" height="10" />
      <rect x="0" y="335" rx="5" ry="5" width="65%" height="10" />
      <rect x="75%" y="335" rx="5" ry="5" width="10%" height="10" />
      <rect x="0" y="355" rx="5" ry="5" width="65%" height="10" />
      <rect x="75%" y="355" rx="5" ry="5" width="30%" height="10" />
      <rect x="0" y="375" rx="5" ry="5" width="65%" height="10" />
      <rect x="75%" y="375" rx="5" ry="5" width="30%" height="10" />
      <rect x="0" y="395" rx="5" ry="5" width="65%" height="8" />
      <rect x="75%" y="395" rx="5" ry="5" width="30%" height="8" />
      <rect x="0" y="415" rx="5" ry="5" width="65%" height="8" />
      <rect x="75%" y="415" rx="5" ry="5" width="30%" height="8" />
      <rect x="0" y="445" rx="5" ry="5" width="65%" height="8" />
      <rect x="75%" y="445" rx="5" ry="5" width="30%" height="8" />
      <rect x="0" y="465" rx="5" ry="5" width="65%" height="8" />
      <rect x="75%" y="465" rx="5" ry="5" width="30%" height="8" />
      <rect x="0" y="485" rx="5" ry="5" width="65%" height="8" />
      <rect x="75%" y="485" rx="5" ry="5" width="30%" height="8" />
      <rect x="0" y="505" rx="5" ry="5" width="65%" height="8" />
      <rect x="75%" y="505" rx="5" ry="5" width="30%" height="8" />
      <rect x="0" y="525" rx="5" ry="5" width="65%" height="8" />
      <rect x="75%" y="525" rx="5" ry="5" width="30%" height="8" />
      <rect x="75%" y="550" rx="5" ry="5" width="10%" height="10" />
      <circle cx="76.5%" cy="590" r="18" />
      <circle cx="80%" cy="590" r="18" />
      <circle cx="83.5%" cy="590" r="18" />
      <circle cx="87%" cy="590" r="18" />
      <circle cx="90.5%" cy="590" r="18" />
      <circle cx="94%" cy="590" r="18" />
    </ContentLoader>
  )
}

export const ButtonLoader = props => ( // 👈️ Loading Button
  <ContentLoader width={355} height={600} viewBox="0 0 355 600" {...props}>
    <rect x="4" y="8" rx="16" ry="16" width="7" height="86" />
    <rect x="6" y="8" rx="16" ry="16" width="675" height="8" />
    <rect x="6" y="86" rx="16" ry="16" width="669" height="8" />
    <rect x="350" y="8" rx="16" ry="16" width="6" height="86" />
    <rect x="25" y="25" rx="16" ry="16" width="200" height="50" />
    <rect x="240" y="25" rx="3" ry="3" width="100" height="10" />
    <rect x="240" y="45" rx="3" ry="3" width="100" height="10" />
    <rect x="240" y="65" rx="3" ry="3" width="100" height="10" />
  </ContentLoader>
)

export const ClockInClockOutLoader = props => ( // 👈️ Loading ClockInClockOutLoader
  <ContentLoader width={'100%'} height={310} {...props}>
   <circle cx="10%" cy="35" r="20" />
   <circle cx="50%" cy="130" r="100" />
   <circle cx="90%" cy="35" r="20" />
   <rect x="0" y="260" rx="0" ry="0" width={'100%'} height="50" />
  </ContentLoader>
)

export const BarChartLoader = props => ( // 👈️ Loading BarChartLoader
  <ContentLoader 
    width="100%"
    height="100%" 
    viewBox="0 25 400 350" 
    backgroundColor="#f3f3f3" 
    foregroundColor="#ecebeb" 
    {...props}
  >
    <rect x="25" y="25" rx="4" ry="4" width="20" height="20" />
    <rect x="50" y="30" rx="3" ry="3" width="50" height="10" />
    <rect x="125" y="25" rx="4" ry="4" width="20" height="20" />
    <rect x="150" y="30" rx="3" ry="3" width="50" height="10" />
    <rect x="225" y="25" rx="4" ry="4" width="20" height="20" />
    <rect x="250" y="30" rx="3" ry="3" width="50" height="10" />

    <rect x="25" y="70" rx="4" ry="4" width="305" height="400" />

    <rect x="25" y="480" rx="3" ry="3" width="305" height="10" />

    <rect x="5" y="70" rx="3" ry="3" width="10" height="400" />
  </ContentLoader>
)
